import MetricViewContainer from "./container";
import MetricView from "./component";
export { MetricView, MetricViewContainer };
export default MetricViewContainer;



// WEBPACK FOOTER //
// ./client/modules/AnalyticsMetric/components/MetricView/index.ts